import React, { useState } from "react";
import { GoArrowDownRight } from "react-icons/go";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const Qutaionfrom = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    freight_type: "",
    date: "",
    slocation:"",
    elocation:"",
    device_token: "website-app",
    status: "1",
  });

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (name === "mobile") {
      const onlyDigits = value.replace(/\D/g, "").slice(0, 15);
      setFormData((prev) => ({ ...prev, [name]: onlyDigits }));
    } else if (name === "name") {
      const onlyAlphabets = value.replace(/[^a-zA-Z ]/g, "");
      setFormData((prev) => ({ ...prev, [name]: onlyAlphabets }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validateForm = () => {
    const { name, email, mobile } = formData;
    if (!name.trim()) return toast.error("Name is required");
    if (!/^[A-Za-z\s]+$/.test(name))
      return toast.error("Name must be letters only");
    if (!email.trim()) return toast.error("Email is required");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      return toast.error("Invalid email");
    if (!/^\d{10,15}$/.test(mobile))
      return toast.error("Mobile must be 10 to 15 digits");
    
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    try {
        console.log(formData);

      const response = await axios.post(
        "https://pegiora.com/courier/public/api/storeQuotation",
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      const { data } = response;
      console.log(response.status);
      if (response.status === 200) {
         toast.success("Quotation add successful!");
       
        setFormData({
          name: "",
          email: "",
          mobile: "",
          password: "",
          confirmPassword: "",
          device_token: formData.device_token,
          status: "1",
        });
      } else {
        if (Array.isArray(data.message)) {
          data.message.forEach((msg) => toast.error(msg));
        } else if (typeof data.message === "string") {
          toast.error(data.message);
        } else {
          toast.error("Something went wrong.");
        }
      }
    } catch (error) {
      if (error.response?.data?.errors) {
        const errors = Object.values(error.response.data.errors).flat();
        errors.forEach((msg) => toast.error(msg));
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Failed to register. Please try again.");
      }
    }
  };

  return (
    <>
      <section
        className="home-herobanner"
        style={{
          backgroundImage: "url('/image/banner.png')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-6 col-sm-12 ">
              <div className="shadow booking-delivery dri-bnnner">
                <h2>
                  Get Freight Transportation Quote
                </h2>
                <p className="driver-bpara">
                  Cowtown Logistics Freight Management is a leading transportation provider, supplying shipping to 48 states in the continental US and Canada. We are committed to the successful and timeous delivery of your freight. Our dedicated team answers customer calls in less than a minute because we believe in speedy responses to get your freight moving ASAP.
                </p>

                {/* <Link
                  to="https://pegiora.com/dashboard12/"
                  className="btn-start-bnr" target="_blank"
                >
                  Get Started <span className="ms-2">→</span>
                </Link> */}

                <div className="driver-banr-img">
                  <img src="/image/driver-banner-short.png" alt="redix" />
                </div>
              </div>
            </div>
            {/* Right Section */}
            <div className="col-md-6 col-lg-6 col-sm-12">
              <div className="bg-white shadow bookingformhome">
                <h2 className="fw-bold">We personalize each delivery quote</h2>
                <p>Complete the form below to have someone from our team contact you! 
                    Want a quicker freight shipping quote? Call us! +1 866-261-9814</p>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Full Name*</label>
                        <div className="input-box">
                          <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="Enter your full name"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Company Name*</label>
                        <div className="input-box">
                          <input
                            type="text"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            placeholder="Enter your Company Name"
                            required
                          />
                        </div>
                      </div>
                    </div>


                    <div className="col-lg-12 col-md-12 col-sm-12">
                      <div className="mb-3">
                        <label>Email address*</label>
                        <div className="input-box">
                          <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email address"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Phone Number*</label>
                        <div className="input-box">
                          <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile}
                            onChange={handleChange}
                            placeholder="Enter your phone number"
                            required
                          />
                        </div>
                      </div>
                    </div>


                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Freight Type*</label>
                        <div className="input-box">
                          <input
                            name="freight_type"
                            value={formData.freight_type}
                            onChange={handleChange}
                            placeholder="Enter your Freight Type"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Pickup Date*</label>
                        <div className="input-box">
                          <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            placeholder="Enter new Pickup Date"
                            required
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Starting Location*</label>
                        <div className="input-box">
                          <input
                            name="slocation"
                            value={formData.slocation}
                            onChange={handleChange}
                            placeholder="city & zip"
                            required
                          />
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-lg-6 col-md-6 col-sm-12">
                      <div className="mb-3">
                        <label>Destination*</label>
                        <div className="input-box">
                          <input
                            name="elocation"
                            value={formData.elocation}
                            onChange={handleChange}
                            placeholder="city & zip"
                            required
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* <div className="tems-driverregi form-check ms-0">
                    <input
                      type="checkbox"
                      className="form-check-input mx-2"
                      id="exampleCheck1"
                      required
                    />
                    <label className="form-check-label" htmlFor="exampleCheck1">
                      I agree to all <Link to="/terms">Terms & Conditions</Link>{" "}
                      and <Link to="/privacy">Privacy Policy</Link>
                    </label>
                  </div> */}

                  <button type="submit" className="cta-button">
                    Submit
                  </button>

                  {/* <p className="signin-text">
                    Already have an account?{" "}
                    <a href="#">Sign in on Mobile App.</a>
                  </p> */}
                </form>
              </div>

             
            </div>
          </div>
        </div>
      </section>
        
    </>
  );
};

export default Qutaionfrom;
